import React from "react";

import TermsPageV1 from "../../component/pages/TermsPage";
import TermsPageV2 from "../../V2/components/pages/TermsPage";

function Terms() {
  const isV2 = process.env.NEXT_PUBLIC_REACT_APP_SKIN === "taxnumber" 
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4";
  if (isV2) {
    return (
      <TermsPageV2 />
    )
  }

  return (
    <TermsPageV1 />
  );
}

export default Terms;
